import io from 'socket.io-client';

// Detectar automáticamente la URL del socket según el entorno
const getSocketUrl = () => {
    // Prioridad 1: variable de entorno explícita (bakeada en el build de producción)
    if (import.meta.env.VITE_SOCKET_URL) {
        return import.meta.env.VITE_SOCKET_URL;
    }

    const isPrivateIP = window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.match(/^192\.168\./) ||
        window.location.hostname.match(/^10\./) ||
        window.location.hostname.match(/^172\.(1[6-9]|2[0-9]|3[0-1])\./);

    if (!isPrivateIP) {
        // Producción con dominio público: socket en el mismo dominio
        return `${window.location.protocol}//${window.location.hostname}`;
    }

    // Desarrollo local o red privada
    const backendPort = import.meta.env.VITE_BACKEND_PORT || '63000';
    return `http://${window.location.hostname}:${backendPort}`;
};

const socketUrl = getSocketUrl();
console.log('socketUrl (auto-detected):', socketUrl);

class SocketApi {
    
    constructor() {
        this.socket = null;
    }

    getSocketId = () => {
        if (!this.socket || !this.socket.id) {
            console.error('Socket: SocketId not available');
            return null;
        }
        console.log('Socket: SocketId', this.socket.id);
        return this.socket.id;
    };

    connect() {
        if (this.socket) return;
        try {
            this.socket = io(socketUrl);

            this.socket.on('connect', () => {
                console.log('Socket: Connected');
            });

            this.socket.on('disconnect', () => {
                console.log('Socket: Disconnected');
            });
        } catch (error) {
            console.error('Socket: Connection Error', error);
            this.connect(); // Intenta reconectar
        }
    }

    listenProcess(onRecivedData) {
        if (!this.socket.connected) return;

        this.socket.on('processFromSendRequest', (data) => {
            onRecivedData(data);
        });
    }

    /**
     * Unirse a la sala de logs en tiempo real (solo admins).
     * @param {function} onLog - Callback que recibe cada entrada de log
     * @param {function} onJoined - Callback cuando la sala es confirmada
     */
    joinAdminLogs(onLog, onJoined) {
        if (!this.socket) return;
        const token = localStorage.getItem('authToken');
        this.socket.emit('join-admin-logs', { token });
        this.socket.on('admin-logs-joined', () => { if (onJoined) onJoined(); });
        this.socket.on('admin:log', onLog);
    }

    leaveAdminLogs() {
        if (!this.socket) return;
        this.socket.emit('leave-admin-logs');
        this.socket.off('admin:log');
        this.socket.off('admin-logs-joined');
    }

    disconnect () {
        this.socket.disconnect();
        console.log('Socket: Disconnected');
    }
}

export default SocketApi;